var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKortoLogotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 558.43 212.6",
    style: {
      enableBackground: "new 0 0 558.43 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#21A5AA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.55,81.2c-3.17-3.21-6.93-5.73-11.25-7.57c-4.33-1.84-8.95-2.76-13.86-2.76c-4.86,0-9.43,0.92-13.73,2.76 c-4.29,1.84-8.04,4.36-11.25,7.57c-3.21,3.21-5.73,6.98-7.56,11.31c-1.84,4.33-2.75,8.96-2.75,13.88c0,4.92,0.92,9.54,2.75,13.84 c1.84,4.3,4.36,8.04,7.56,11.22c3.21,3.18,6.96,5.69,11.25,7.53c4.3,1.84,8.87,2.76,13.73,2.76c4.91,0,9.54-0.92,13.86-2.76 c4.33-1.84,8.08-4.35,11.25-7.53c3.17-3.18,5.68-6.92,7.51-11.22c1.84-4.3,2.76-8.91,2.76-13.84c0-4.92-0.92-9.55-2.76-13.88 C205.23,88.18,202.73,84.41,199.55,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.94,92.51c-1.84-4.33-4.34-8.1-7.51-11.31c-3.17-3.21-6.93-5.73-11.25-7.57 c-4.33-1.84-8.95-2.76-13.86-2.76c-4.86,0-9.43,0.92-13.73,2.76c-4.29,1.84-8.04,4.36-11.25,7.57c-3.21,3.21-5.73,6.98-7.56,11.31 c-1.84,4.33-2.75,8.96-2.75,13.88c0,4.92,0.92,9.54,2.75,13.84c1.84,4.3,4.36,8.04,7.56,11.22c3.21,3.18,6.96,5.69,11.25,7.53 c4.3,1.84,8.87,2.76,13.73,2.76c4.91,0,9.54-0.92,13.86-2.76c4.33-1.84,8.08-4.35,11.25-7.53c3.17-3.18,5.68-6.92,7.51-11.22 c1.84-4.3,2.76-8.91,2.76-13.84C488.69,101.47,487.77,96.84,485.94,92.51z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "286.63,91.54 306.63,91.54 306.63,140.28 329.34,140.28 329.34,91.54 349.34,91.54 349.34,72.32  286.63,72.32  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.49,
    y: 72.32,
    className: "st0",
    width: 57.96,
    height: 19.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.49,
    y: 121.06,
    className: "st0",
    width: 57.96,
    height: 19.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.49,
    y: 96.69,
    className: "st0",
    width: 57.96,
    height: 19.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.63,95.54c0-7.06-2.64-12.94-7.9-17.02c-0.36-0.28-0.75-0.54-1.14-0.81c-0.24-0.17-0.47-0.34-0.73-0.5 c-2.73-1.75-6.11-3.08-10.26-3.91c-0.12-0.02-0.25-0.04-0.37-0.07c-0.88-0.17-1.78-0.32-2.73-0.44c-0.48-0.06-0.98-0.1-1.47-0.15 c-0.66-0.07-1.31-0.14-2-0.19c-1.26-0.08-2.57-0.13-3.92-0.13c-0.01,0-0.02,0-0.03,0c-0.02,0-0.03,0-0.05,0h-36.63v67.95h26.14 h2.36v-8.69l5.88,8.69h9.43h24.88l-15.68-22.89C277.76,114.09,283.63,106.68,283.63,95.54z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "143.68,72.32 117.27,72.32 106.26,72.32 99.26,80.35 99.26,72.32 70.87,72.32 70.87,140.28  71.7,140.28 79.4,140.29 103.78,140.28 117.08,140.28 144.16,140.28 114.36,106.31  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKortoLogotype);
export default __webpack_public_path__ + "static/media/korto-logotype.2b2bf2a3b185d0b9cb53e0fcc541b347.svg";
export { ForwardRef as ReactComponent };